(function () {
    'use strict';

    angular.module('swif.ui')
    .controller('ExportModalController', ExportController);

    function ExportController ($scope, gettextCatalog){
        'ngInject';
        console.log('init ExportController');

        $scope.model.exportCSV = {
            quantity: {},
            fields: {},
            skipHeader: $scope.action.skipHeader
        };

        // Quantity choice option
        if ($scope.action.quantityChoice) {
            var quantityOptions = [
                {id: 'matchingStock', name: gettextCatalog.getString('Same as the quantity in stock')},
                {id: 'manual', name: gettextCatalog.getString('Set manually')}
            ];

            $scope.model.exportCSV.quantity = {
                choices: quantityOptions,
                selected: quantityOptions[0],
                manual: 1
            };
            $scope.changeOption = function() {
                if ($scope.model.exportCSV.quantity.selected.id === 'matchingStock'){
                    $scope.model.exportCSV.quantity.manual = 0;
                }
            };
        }

        // Field choice options
        var fieldsOptions = [];

        if ($scope.action.exportOnlyFields) {
            if ($scope.action.exportOnlyTitle) {
                var label = $scope.action.exportOnlyTitle;
            } else {
                var label = gettextCatalog.getString('Only some specific fields');
            }

            fieldsOptions.push({
                id: 'only',
                name: label
            });
        }
        if ($scope.action.exportFields) {
            fieldsOptions.push({
                id: 'all',
                name: gettextCatalog.getString('All fields')
            });
        }

        $scope.model.exportCSV.fields = {
            choices: fieldsOptions,
            selected: fieldsOptions[0]
        };
    }

})();
